import React from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  VStack,
  HStack,
  useColorModeValue,
  Container,
  Image,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
// import Header from "../components/Header";
import { pxToRem } from "../utils/editor.ts";

const PaymentFailurePage: React.FC = () => {
  const navigate = useNavigate();

  const bgGradient = useColorModeValue(
    "linear(to-br, #e6f3ff, #f0f8ff, #e6f3ff)",
    "gray.800"
  );

  const handleHomePage = () => {
    navigate("/edit");
  };

  const handleClose = () => {
    navigate("/payment");
  };

  return (
    <Box
      bgGradient={bgGradient}
      h="100%"
      padding={pxToRem(30)}
      pt={0}
      overflowY={"auto"}
      display="flex"
      flexDirection="column"
      position="relative"
    >
      
      <Image
        w="100%"
        h="100%"
        left={'0'}
        top={'0'}
        position="fixed"
        src="/static/payment/payment-bg.png"
        objectFit="cover"
        objectPosition="center"
      />
      {/* Decorative background elements */}
      <Box
        position="absolute"
        top="20%"
        left="10%"
        w={pxToRem(200)}
        h={pxToRem(200)}
        bg="rgba(29, 138, 255, 0.1)"
        borderRadius="full"
        filter={`blur(${pxToRem(60)})`}
        zIndex={0}
      />
      <Box
        position="absolute"
        bottom="20%"
        right="10%"
        w={pxToRem(300)}
        h={pxToRem(300)}
        bg="rgba(29, 138, 255, 0.08)"
        borderRadius="full"
        filter={`blur(${pxToRem(80)})`}
        zIndex={0}
      />

      {/* Header with user menu */}
      {/* <Header /> */}

      {/* Main content */}
      <Flex flex="1" align="center" justify="center" zIndex={1}>
        <Container maxW={pxToRem(1052)}>
          {/* Title Section */}

          {/* Payment Success Card */}
          <Box
            borderRadius={pxToRem(20)}
            pt={pxToRem(20)}
            pb={pxToRem(28)}
            paddingX={pxToRem(30)}
            boxShadow={`0 ${pxToRem(10)} ${pxToRem(40)} rgba(0, 0, 0, 0.1)`}
            maxW={pxToRem(998)}
            mx="auto"
            border="1px solid #D3D7E2"
            bg="#F5F6FA"
          >
            <Box>
              {/* Payment Failured Title */}
              <Heading
                as="h2"
                fontSize={pxToRem(32)}
                fontWeight="bold"
                color="gray.800"
              >
                Payment Failured
              </Heading>

              {/* Description */}
              <Text
                m={0}
                fontSize={pxToRem(20)}
                color="gray.600"
                lineHeight="1.5"
              >
                We couldn't process your payment.
              </Text>
              <Image
                src="/static/payment/payment-fail.png"
                w={pxToRem(138)}
                h={pxToRem(138)}
                margin={'12px auto'}
              />

              {/* Plan Details */}
              <VStack
                // spacing={pxToRem(12)}
                w="full"
                p={pxToRem(20)}
                borderRadius={pxToRem(12)}
              >
                <HStack w="full" justifyContent={"center"} mt={pxToRem(26)}>
                  <Text
                    fontSize={pxToRem(16)}
                    color="#8E9ABC"
                  >
                    If you continue to experience issues, our support team is here to help.
                  </Text>
                </HStack>
              </VStack>

              {/* Action Buttons */}
              <HStack
                spacing={pxToRem(12)}
                w="full"
                pt={pxToRem(16)}
                justifyContent={"center"}
              >
                <Button
                  bg="#1D8AFF"
                  color="#1F1F1F"
                  fontSize={pxToRem(16)}
                  borderRadius={pxToRem(20)}
                  onClick={handleClose}
                  _hover={{ bg: "#1570CD" }}
                  fontWeight="700"
                  h={pxToRem(48)}
                  width={pxToRem(133)}
                  marginRight={pxToRem(200)}
                >
                  Try Again
                </Button>
                <Button
                  fontWeight="700"
                  h={pxToRem(48)}
                  width={pxToRem(133)}
                  fontSize={pxToRem(16)}
                  variant="outline"
                  borderColor="#1D8AFF"
                  color="gray.700"
                  size="lg"
                  borderRadius={pxToRem(20)}
                  onClick={handleHomePage}
                  _hover={{ bg: "gray.50" }}
                >
                  Close
                </Button>
              </HStack>
            </Box>
          </Box>
        </Container>
      </Flex>
    </Box>
  );
};

export default PaymentFailurePage;
